// extracted by mini-css-extract-plugin
export var arrowDownIcon = "Quotes-module__arrowDownIcon--2yq47";
export var arrowRightIconBig = "Quotes-module__arrowRightIconBig--W3b-L";
export var arrowRightIconMid = "Quotes-module__arrowRightIconMid--G7hzd";
export var colLeft = "Quotes-module__colLeft--3lK-c Quotes-module__title--3bwMz";
export var container = "Quotes-module__container--3fWpm";
export var containerIconQuote = "Quotes-module__containerIconQuote--3vwWh";
export var containerIconRightText = "Quotes-module__containerIconRightText--GTO9A";
export var mobileHelperArrow = "Quotes-module__mobileHelperArrow--2d8B2";
export var okIcon = "Quotes-module__okIcon--3g4up";
export var quoteLi = "Quotes-module__quoteLi--1LUvo";
export var quoteText = "Quotes-module__quoteText--1q5T8";
export var rightText = "Quotes-module__rightText--1djQw";
export var row = "Quotes-module__row--sOLCT";
export var subTitleContainer = "Quotes-module__subTitleContainer--1g1wm";
export var title = "Quotes-module__title--3bwMz";
export var titleFlexContainer = "Quotes-module__titleFlexContainer--3q2Sl";